import { z } from 'zod';
const uuid = z.string().uuid();
const identifier = z.string().min(3).max(160).regex(/^[a-z][a-z0-9-]*(?:\.[a-z0-9-]+)+$/);
const versionedIdentifier = z.string().min(5).max(160)
    .regex(/^[a-z][a-z0-9-]*(?:\.[a-z0-9-]+)+\.v[1-9][0-9]*$/);
export const assistantContextRequestSchema = z.strictObject({
    requestId: uuid,
    subjectType: identifier,
    subjectId: uuid.nullable(),
    query: z.string().trim().max(160).nullable().optional(),
    requestedCapabilities: z.array(versionedIdentifier).min(1).max(50),
    redactionProfile: z.string().min(2).max(80).regex(/^[a-z][a-z0-9-]*$/),
    maxFacts: z.number().int().min(1).max(500).default(100),
});
export const assistantContextFactSchema = z.strictObject({
    factType: identifier,
    value: z.record(z.string().min(1).max(120), z.unknown()),
    sourceRevision: z.string().min(1).max(160),
    observedAt: z.string().datetime({ offset: true }),
    redactedFields: z.array(z.string().min(1).max(512)).max(100),
});
export const assistantContextResultSchema = z.strictObject({
    providerId: identifier,
    providerModuleId: z.string().min(2).max(64).regex(/^[a-z][a-z0-9]*(?:-[a-z0-9]+)*$/),
    capability: versionedIdentifier,
    facts: z.array(assistantContextFactSchema).max(500),
    unavailableReason: z.enum(['not-entitled', 'not-enabled', 'permission-denied', 'provider-failed']).nullable(),
});
export class AssistantContextRegistry {
    providers = new Map();
    constructor(providers = []) {
        for (const provider of providers)
            this.register(provider);
    }
    register(provider) {
        if (this.providers.has(provider.capability)) {
            throw new Error(`Assistant context capability already registered: ${provider.capability}`);
        }
        this.providers.set(provider.capability, provider);
    }
    resolve(capability) {
        return this.providers.get(capability) ?? null;
    }
    list() {
        return [...this.providers.values()].sort((left, right) => left.capability.localeCompare(right.capability));
    }
}
export const assistantContextProviderCapability = 'assistant.context-provider-registry.v1';
export const assistantContextProviderSlot = 'platform.server.optional-context';
//# sourceMappingURL=assistant-context.contract.js.map